module.exports = __webpack_public_path__ + "img/guide-view-once.167915f2.svg";